import { Tyre } from "@bundles/tyres/data/models"
import { ETyresSeason } from "@tm/models"

export const extractTyreParameters = (tyreItem: Tyre, front?: boolean) => {
    const [width, secondPart] = front ? tyreItem.sizeFront?.split("/") || "" : tyreItem.sizeRear?.split("/") || ""

    const indexR = secondPart?.indexOf("R")
    const ratio = secondPart?.substring(0, indexR)
    const diameter = secondPart?.substring(indexR)

    return [width, ratio, diameter]
}

export const seasonDisabled = (tyre: Tyre, season: ETyresSeason, sameSize?: boolean) => {
    if (
        sameSize
            ? tyre.seasonFront === ETyresSeason.allSeason
            : tyre.seasonFront === ETyresSeason.allSeason && tyre.seasonRear === ETyresSeason.allSeason
    ) {
        return false
    }
    return sameSize ? tyre.seasonFront !== season : !(tyre.seasonFront === season && tyre.seasonRear === season)
}
